import { useMusic } from '../music';
import { playHaptic } from '../haptics';

export function MusicControls() {
  const { muted, toggle } = useMusic();

  return (
    <button
      type="button"
      className="icon-btn"
      aria-label={muted ? 'Включить музыку' : 'Выключить музыку'}
      aria-pressed={!muted}
      data-cuelume-toggle
      onClick={() => {
        playHaptic('selection');
        toggle();
      }}
    >
      {muted ? (
        <img
          src={`${process.env.PUBLIC_URL}/img/icon-volume-mute.svg`}
          alt=""
          draggable="false"
        />
      ) : (
        <img
          src={`${process.env.PUBLIC_URL}/img/icon-volume-on.svg`}
          alt=""
          draggable="false"
        />
      )}
    </button>
  );
}
